export default __webpack_public_path__ + "899e0b4787c1a183bb96351629348b16.jpg";